import { useState } from 'react';
import type { FormEvent } from 'react';
import { PRODUCT_NAME } from '@goanna-im/shared';
import { login } from '../lib/auth.js';
import type { AuthUser } from '../lib/auth.js';

export function Login({
  navigate,
  onLoggedIn,
}: {
  navigate: (to: string) => void;
  onLoggedIn: (user: AuthUser) => void;
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const result = await login(username, password);
    setBusy(false);
    if (result.ok) {
      onLoggedIn(result.user);
      navigate(result.user.role === 'admin' ? '/admin' : '/producer');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="wrap stack" style={{ paddingTop: '3rem', maxWidth: 420 }}>
      <h1 className="brand" style={{ margin: 0 }}>
        {PRODUCT_NAME}
        <small>Producer sign in</small>
      </h1>
      <form className="card stack" onSubmit={submit}>
        <input
          aria-label="Username"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
        />
        <input
          aria-label="Password"
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />
        {error && <p style={{ color: 'var(--urgent)', margin: 0 }}>{error}</p>}
        <button className="primary" type="submit" disabled={busy || !username || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <button
        className="muted"
        style={{ background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}
        onClick={() => navigate('/')}
      >
        ← Back
      </button>
    </div>
  );
}
